import { animate, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component, signal } from '@angular/core'
import { slideAnimation } from './corp-wizard.animations'

animations: [
    trigger('checkFade', [
        transition(':enter', [
            style({ opacity: 0, transform: 'scale(0.6)' }),
            animate('180ms ease-out',
                style({ opacity: 1, transform: 'scale(1)' }))
        ])
    ])
]

@Component({
    selector: 'corp-wizard',
    imports: [CommonModule],
    animations: [slideAnimation],
    templateUrl: './corp-wizard.component.html'
})
export class CorpWizardComponent {

    steps = [
        { title: 'Account' },
        { title: 'Profile' },
        { title: 'Confirm' }
    ];

    currentStep = signal(0);

    next() {
        if (this.currentStep() < this.steps.length - 1) {
            this.currentStep.update(v => v + 1)
        }
    }

    previous() {
        if (this.currentStep() > 0) {
            this.currentStep.update(v => v - 1)
        }
    }

    progressPercent() {
        return ((this.currentStep() + 1) / this.steps.length) * 100
    }

    getStepClasses(i: number): string {

        if (i === this.currentStep()) {
            return 'bg-red-50 border-2 border-red-700 text-slate-900'
        }

        if (i < this.currentStep()) {
            return 'bg-white border border-slate-300 text-emerald-600'
        }

        return 'bg-white border border-slate-300 text-slate-400'
    }
}